<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import ApexCharts from "apexcharts"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { afterUpdate, onDestroy, onMount } from "svelte"

  /**
   * @type {Array} - it contains chart data
   */
  export let chartData = []

  /**
   * @type {Boolean} - for loading screen Show or hide
   */
  let apiCallBtnDisable = false

  //used for rendering chart
  let chart

  /**
   * @type {HTMLElement} - chart div element
   */
  let chartDiv

  /**
   * @type {Object} - it contains the properties for customizing chart
   */
  let options = {
    chart: {
      height: 500,
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
      // curve: "straight",
      width: 2,
    },
    dataLabels: {
      enabled: false,
    },
    dropShadow: {
      enabled: true,
      top: 0,
      left: 0,
      // blur: 3,
      // color: ["#5968E9", "#f8a500", "#4DE5BE", "#58FE69"],
      opacity: 0.2,
    },
    legend: {
      // position: "top",
      // horizontalAlign: "right",
      labels: {
        colors: "#666666",
        useSeriesColors: false,
      },
    },
    // fill: {
    //   type: "solid",
    //   type: "gradient",
    //   // color: ["#5968E9", "#58C0FE", "#4DE5BE", "#9259E9"],
    //   // gradient: {
    //   //   shadeIntensity: 1,
    //   //   opacityFrom: 0.7,
    //   //   // gradientToColors: ["transparent", "transparent", "transparent", "transparent"],
    //   //   opacityTo: 0.9,
    //   //   stops: [0, 90, 100],
    //   // },
    // },
    series: [
      {
        name: "SENT",
        color: "#ff6a00",
      },
      {
        name: "DELIVERED",
        color: "#00D515",
      },
      {
        name: "BOUNCED",
        color: "#F03232",
      },
      {
        name: "OPEN",
        color: "#00B2FF",
      },
      {
        name: "CLICKS",
        color: "#B100FF",
      },
      {
        name: "UNIQUE CLICKS",
        color: "#0003FF",
      },
      {
        name: "UNIQUE OPEN",
        color: "#FFE406",
      },
    ],
    xaxis: {
      labels: {
        style: {
          colors: ["#707175"],
        },
      },
      axisBorder: {
        show: false,
        color: "#858585",
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      logarithmic: false,
      logBase: 2,
      axisBorder: {
        show: false,
        color: "#858585",
      },
      labels: {
        show: false,
        style: {
          colors: ["#707175"],
        },
        formatter: function (value) {
          let modifiedValue = Math.log(Math.round(Math.pow(2, value)) - 1) / Math.log(2)
          return value != 0 ? Math.floor(modifiedValue * 100) / 100 : 0
        },
      },
    },
    grid: {
      show: true,
      borderColor: "#ffffff",
      strokeDashArray: 1,
      position: "back",
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      row: {
        colors: undefined,
        opacity: 0.5,
      },
      column: {
        colors: undefined,
        opacity: 0.5,
      },
      // padding: {
      //   top: 0,
      //   right: 0,
      //   bottom: 0,
      //   left: 0,
      // },
    },
    tooltip: {
      y: {
        formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
          return value - 1 // actival value added to value 1 so here subract that value 1
        },
      },
    },
  }

  afterUpdate(() => {
    if (chartData.length > 0) reAsignChartPoint()
  })

  // while change the chart data
  $: if (chartData.length > 0) reAsignChartPoint($ApplicationState.darkMode, chartData)

  /**
   * @description Assign chart data value to options to render charts
   */
  const reAsignChartPoint = () => {
    apiCallBtnDisable = true
    let sent = []
    let delivered = []
    let bounced = []
    let click = []
    let open = []
    let uniqueOpen = []
    let uniqueClick = []
    let date = []
    let dateColour = []

    for (let i = 0; i < chartData.length; i++) {
      //adding +1 for converting value into logirthemic value. (log 0 base 2 = undefined) but (log 1 base 2 = 0)
      if (chartData[i].sent >= 6) options.yaxis.logarithmic = true
      if (chartData[i].delivered >= 6) options.yaxis.logarithmic = true
      if (chartData[i].bounce >= 6) options.yaxis.logarithmic = true
      if (chartData[i].opens >= 6) options.yaxis.logarithmic = true
      if (chartData[i].clicks >= 6) options.yaxis.logarithmic = true
      if (chartData[i].uniqueClick >= 6) options.yaxis.logarithmic = true
      if (chartData[i].uniqueOpen >= 6) options.yaxis.logarithmic = true
      sent.push(chartData[i].sent + 1)
      delivered.push(chartData[i].delivered + 1 || 1) // ||1 for getting undefined delivered value
      bounced.push(chartData[i].bounce + 1)
      open.push(chartData[i].opens + 1)
      click.push(chartData[i].clicks + 1)
      uniqueClick.push(chartData[i].uniqueClick + 1)
      uniqueOpen.push(chartData[i].uniqueOpen + 1)
      let newDate = new Date(chartData[i].date)
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      const month = monthNames[newDate.getMonth()]
      const day = newDate.getDate()
      const formattedDate = `${month} ${day}`
      // let formattedDate = new Date(chartData[i].date).toLocaleDateString("en-US", { month: "short", day: "numeric" })
      date.push(formattedDate)
      dateColour.push("#707175")
    }

    // options.xaxis.axisBorder.color = $ApplicationState.darkMode ? "#3f3f3f" : "#cfcfcf"
    // options.yaxis.axisBorder.color = $ApplicationState.darkMode ? "#8C8C8C" : "#cfcfcf"
    options.grid.borderColor = $ApplicationState.darkMode ? "#2e2e2e" : "#dedede"
    options.grid.borderColor = $ApplicationState.darkMode ? "#2e2e2e" : "#dedede"
    options.tooltip.theme = $ApplicationState.darkMode ? "dark" : "light"
    options.xaxis.categories = date
    options.xaxis.labels.style.colors = dateColour
    options.series[0].data = sent
    options.series[1].data = delivered
    options.series[2].data = bounced
    options.series[3].data = open
    options.series[4].data = click
    options.series[5].data = uniqueClick
    options.series[6].data = uniqueOpen
    createChartElem()
  }

  /**
   * @description create the div for showing chart
   */
  const createChartElem = () => {
    if (chartData.length > 0) {
      if (document.getElementById("chart")) document.getElementById("chart").remove()
      const node = document.createElement("div")
      node.id = "chart"
      if (chartDiv) chartDiv.appendChild(node)
      loadChart()
    }
  }
  // const changeChartDate = (e) => {
  //   if (e.detail.startDate) startDate = e.detail.startDate
  //   if (e.detail.endDate) endDate = e.detail.endDate
  //   showFilterForm = false
  //   fetchChartData()
  // }

  // const changeChartDate = async () => {
  //   await fetchChartData()
  // }

  /**
   * @description For rendering chart
   */
  const loadChart = () => {
    if (document.querySelector("#chart")) {
      chart = new ApexCharts(document.querySelector("#chart"), options)
      chart.render()
    }
    apiCallBtnDisable = false
  }

  onDestroy(() => {
    if (chart) chart.destroy()
  })
</script>

<!-- <svelte:window
  on:click={() => {
    if (showFilterForm) showFilterForm = false
  }}
/> -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- <div id="chart" /> -->
{#if !chartData.length}
  <div class="text-secondary2 select-none rounded-md bg-[#f7f7f7] py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no chart data</div>
{:else}
  <div bind:this={chartDiv} class="relative" />
{/if}
{#if apiCallBtnDisable}
  <LoadingScreen msg={"chart data loading"} />
{/if}
